import React, { Component, useEffect } from 'react'
import logo from './logo.svg';
import { Button } from 'antd';
import './App.css';
import { Layout, Menu, Breadcrumb, Col, Row } from 'antd';
import { Typography } from 'antd';
import {
  BrowserRouter,
  Switch,
  Route,
  Link,
  useLocation,
  withRouter
} from 'react-router-dom'
import MainHeader from "./MainHeader";
import MainBody from './MainBody';
import MainFooter from "./MainFooter";

import LoginForm from './LoginForm'
import ReactDOM from 'react-dom'
import axios from 'axios'

import {connect, Provider} from 'react-redux'
import {store}from './store';
import {PersistGate} from "redux-persist/integration/react";
import {persistor} from "./store";
import { pdfjs } from 'react-pdf';
import * as authService from './authService';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

// Set base URL from environment or default to /api/
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || '/api/'
// withCredentials not needed — same domain via CloudFront proxy

// Axios 401 interceptor: attempt token refresh via backend, then retry
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = store.getState().refreshToken;
        if (!refreshToken) throw new Error('No refresh token');
        const result = await authService.refreshSession(refreshToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${result.id_token}`;
        store.dispatch({
          type: 'SET_COGNITO_TOKENS',
          idToken: result.id_token,
          refreshToken: refreshToken,
        });
        originalRequest.headers['Authorization'] = `Bearer ${result.id_token}`;
        return axios(originalRequest);
      } catch (refreshErr) {
        // Token refresh failed, force logout
        delete axios.defaults.headers.common['Authorization'];
        persistor.purge();
        store.dispatch({ type: 'RESET' });
        window.location.href = '/login';
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(error);
  }
);

function mapReduxStateToReactProps(state) {
  return {
    token: state.token,
    session: state.session
  }
}

const { Title } = Typography;
const { Header, Content, Footer } = Layout;

function _ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
      window.scrollTo(0, 0);
  }, [pathname]);
  return props.children
}

const ScrollToTop = withRouter(_ScrollToTop)
class App extends React.Component {
  state = {
    name:'',
    user_type:'',
  }

  constructor(props){
    super(props);
  }

  componentDidMount() {
    if (this.props.token){
      // Set auth header from persisted token
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.props.token}`;
    }
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <MainHeader token={this.props.token} session={this.props.session}></MainHeader>
            <MainBody token={this.props.token} session={this.props.session}/>
            <MainFooter />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default connect(mapReduxStateToReactProps)(App);
